<div (click)="open($event)" class="icon-toggle">
  <wchfs-icon-it [svgIcon]="'pso:info_m'" [size]="26"></wchfs-icon-it>
</div>
